import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Upload, Download } from 'lucide-react';

const Header: React.FC = () => {
  const location = useLocation();
  const isDemoMode =
    location.pathname === '/demo' || location.pathname.startsWith('/demo/');
  const encodePath = isDemoMode ? '/demo/upload' : '/upload';
  const decodePath = isDemoMode ? '/demo/download' : '/download';
  const isEncodeActive = isDemoMode
    ? location.pathname === '/demo' || location.pathname === '/demo/upload'
    : location.pathname === '/' || location.pathname === '/upload';
  const isDecodeActive = isDemoMode
    ? location.pathname === '/demo/download'
    : location.pathname === '/download';

  return (
    <header className="bg-secondary-bg border-b border-gold p-4 mb-6">
      <div className="container flex justify-between items-center">
        <div className="flex items-center gap-3">
          <img src="\Chithram_BW.png" alt="Logo" style={{ width: '250px', height: '100px', borderRadius: '10px' }} />
        </div>
        
        <nav className="flex gap-4">
          <Link
            // to="/upload"
            to={encodePath}
            className={`flex items-center gap-2 px-6 py-5 rounded-lg transition-colors text-xl border-2 border-white border-radius-10 border-solid ${
              // location.pathname === '/' || location.pathname === '/upload'
              isEncodeActive
                ? 'bg-gold text-black font-semibold text-lg border-white border-2 border-radius-10 border-solid hover:bg-gold hover:text-black'
                : 'text-white hover:bg-gold hover:text-black'
            }`}
          >
            <Upload size={18} />
            Engrave
          </Link>
          
          <Link
            // to="/download"
            to={decodePath}
            className={`flex items-center gap-2 px-6 py-5 rounded-lg transition-colors text-xl border-2 border-gold border-radius-10 border-solid ${
              // location.pathname === '/download'
              isDecodeActive
                ? 'bg-gold text-black font-semibold border-white border-2 border-radius-10 border-solid hover:bg-gold hover:text-black'
                : 'text-white hover:bg-gold hover:text-black'
            }`}
          >
            <Download size={18} />
            Decode
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
